import { render, staticRenderFns } from "./TaskEditContractorForm.vue?vue&type=template&id=36c4ac50&"
import script from "./TaskEditContractorForm.vue?vue&type=script&lang=js&"
export * from "./TaskEditContractorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports